import * as React from "react"
import type { IconProps } from "../types"

const BuildingMini = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 12, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="white"
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          fillRule="evenodd"
          d="M4 3V19H2V21H22V19H20V3H4ZM8 7H9H10H11V9H10H9H8V7ZM14 7H13V9H14H15H16V7H15H14ZM8 11H9H10H11V13H10H9H8V11ZM14 11H13V13H14H15H16V11H15H14ZM8 15H9H10H11V17H10H9H8V15ZM14 15H13V17H14H15H16V15H15H14Z"
        />
      </svg>
    )
  }
)
BuildingMini.displayName = "BuildingMini"

export default BuildingMini
